import type {RdvActivationStatusResponse, UpdateRdvActivationPayload} from "@mytour/shared";
import axios from "axios";

export const rdvActivationApiService = {
  async getRdvActivationStatus(): Promise<RdvActivationStatusResponse> {
    const result = await axios.get<RdvActivationStatusResponse>("api/rdv-activation/");
    return result.data;
  },

  async updateRdvActivation(
    payload: UpdateRdvActivationPayload
  ): Promise<RdvActivationStatusResponse> {
    const result = await axios.post<RdvActivationStatusResponse>("api/rdv-activation/", payload);
    return result.data;
  },
};
